import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { isTouch } from "../../../../utils/screenUtil";
import PdfForm from "./PdfForm";


function PdfFormModal({ title, isOpen, state, dispatch, onAccept, onClose }) {
  const { t } = useTranslation();
  const [modalCardStyle] = useState(isTouch() ? {} : { width: 924 });

  return (
    <div className={`modal ${isOpen ? "is-active" : ""}`} style={{ zIndex: 30 }}>
      <div className="modal-background" />
      <div className="modal-card" style={modalCardStyle}>
        <header className="modal-card-head">
          <p className="modal-card-title">{title}</p>
          <button className="delete" aria-label="close" onClick={onClose} />
        </header>
        <section className="modal-card-body overflow-x-scroll">
          <div className="title has-text-centered">{state.pdfForm.name}</div>
          <PdfForm
            pdf={state.pdfForm.url}
            scale={state.pdfForm.scale}
            pdfFormStateObjectRef={state.pdfForm}
            dispatch={dispatch}
          />
        </section>
        <footer className="modal-card-foot">
          <div className="container buttons is-right">
            <button className="button is-success" onClick={onAccept}>
              {t("requests.submission.pdf.modal.accept")}
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default PdfFormModal;
